import { render, staticRenderFns } from "./navTabs.vue?vue&type=template&id=7978e232"
import script from "./navTabs.vue?vue&type=script&lang=js"
export * from "./navTabs.vue?vue&type=script&lang=js"
import style0 from "./navTabs.vue?vue&type=style&index=0&id=7978e232&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports